import { MouseEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import BrandMark from './BrandMark';
import classes from './HomeLogo.module.scss';

const HomeLogo = () => {
  const isAuthenticated = useSelector((s: RootState) => s.auth.isAuthenticated);
  const target = isAuthenticated ? '/my' : '/';
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    if (location.pathname !== target) navigate(target);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Link to={target} onClick={handleClick} className={classes.wrap} aria-label="Home" title="Home">
      <BrandMark size={30} className={classes.mark} />
      <span className={classes.word}>Strand</span>
    </Link>
  );
};

export default HomeLogo;
